export const LOYALTY_ATTACH_CHANGE_VALUE = 'LOYALTY_ATTACH_CHANGE_VALUE';
